export enum TimeRange {
  Month_1 = 30,
  Month_6 = 180,
  Month_12 = 365,
  Everyone = 0,
}
